import Vue from 'vue'
import FeatherIcon from '@core/components/feather-icon/FeatherIcon.vue'
import GlobalSpinner from './components/GlobalSpinner.vue'

Vue.component(FeatherIcon.name, FeatherIcon)

Vue.component(GlobalSpinner.name, GlobalSpinner)
